import {FormikErrors} from 'formik';
import React, {ReactElement, ReactNode} from 'react';
import Button, {ButtonVariant} from '../Buttons/Button/Button';
import PageErrors from '../PageErrors/PageErrors';

import './SinglePageForm.scss';

interface SinglePageFormProps<FormValues> {
  className?: string;
  errors?: FormikErrors<FormValues>;
  isSubmitLoading?: boolean;
  submitButtonLabel?: string;
  submitButtonId?: string;
  submitButtonTestId?: string;
  children: ReactNode;
  onSubmit: (formEvent: React.FormEvent<HTMLFormElement>) => void;
  afterSubmitContent?: ReactNode;
  isFormDisabled?: boolean;
}

function SinglePageForm<FormValues = unknown>({
  errors = {},
  className,
  onSubmit,
  children,
  isSubmitLoading,
  afterSubmitContent,
  submitButtonLabel,
  submitButtonId,
  submitButtonTestId,
  isFormDisabled,
}: SinglePageFormProps<FormValues>): ReactElement {
  return (
    <form noValidate className={`singlePageForm ${className || ''}`.trim()} onSubmit={onSubmit}>
      {children}
      {submitButtonLabel && (
        <div className="singlePageForm__submitButton">
          <Button
            ariaLabel={submitButtonLabel}
            isDisabled={isSubmitLoading || isFormDisabled}
            testId={submitButtonTestId}
            id={submitButtonId}
            type="submit"
            variant={ButtonVariant.PRIMARY}
            onClick={() => {
              // no-op
            }}
          >
            {submitButtonLabel}
          </Button>
        </div>
      )}
      {afterSubmitContent}
      {Object.keys(errors).length > 0 && <PageErrors<FormValues> errors={errors} />}
    </form>
  );
}

export default SinglePageForm;
